import getAll from './getAll'
import getOne from './getOne'
import create from './create'
import createMany from './createMany'
import update from './update'
import destroy from './delete'
import getMany from './getMany'
import getManyReference from './getManyReference'
import deleteMany from './deleteMany'
import updateMany from './updateMany'
import { withServerErrorMessage } from '../../lib/serverErrors'

// Só CREATE e UPDATE: são os que alimentam formulário, onde o 400 traz `body.errors` por campo.
const withServerErrors = (action) => async (resourceName, params) => {
  try {
    return await action(resourceName, params)
  } catch (error) {
    throw withServerErrorMessage(error)
  }
}

export default (type, resourceName, params) => {
  const actions = {
    GET_LIST: getAll,
    GET_ONE: getOne,
    GET_MANY_REFERENCE: getManyReference,
    GET_MANY: getMany,
    CREATE: withServerErrors(create),
    "createMany": createMany,
    UPDATE: withServerErrors(update),
    DELETE: destroy,
    DELETE_MANY: deleteMany,
    UPDATE_MANY: updateMany,
  }

  return actions[type] ? actions[type](resourceName, params) : void 0
}
